import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyBootModule } from "owa-bundling-light";

const lazyBootModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(() => import(/* webpackChunkName: "StartAccountDataGql" */ "./lazyIndex"), { name: "StartAccountDataGql" });

export const lazyGetStartAccountDataViaGql: LazyAction<typeof lazyIndex.getStartAccountDataViaGql, typeof lazyBootModule> = new LazyAction(lazyBootModule, m => m.getStartAccountDataViaGql);
